"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_options_core_1 = require("owa-options-core");
var store_1 = require("../store/store");
var owa_session_store_1 = require("owa-session-store");
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.select({
    optionState: function () { return store_1.default; },
    userOptions: function () { return owa_session_store_1.getUserConfiguration().ViewStateConfiguration; },
})(function isAttachmentPreferencesOptionDirty(state) {
    var optionState = state.optionState, userOptions = state.userOptions;
    var fromComputer = owa_options_core_1.getFallbackValueIfNull(optionState.fromComputer, userOptions.AttachOrShareLocalFiles);
    var fromOneDrive = owa_options_core_1.getFallbackValueIfNull(optionState.fromOneDrive, userOptions.AttachOrShareCloudFiles);
    return (fromComputer !== userOptions.AttachOrShareLocalFiles ||
        fromOneDrive !== userOptions.AttachOrShareCloudFiles);
});
//# sourceMappingURL=isAttachmentPreferencesOptionDirty.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-attachment-preferences-option/lib/utils/isAttachmentPreferencesOptionDirty.js
// module id = 4983
// module chunks = 2